"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportFile = exports.setCookieByJwtExpire = exports.setCookie = exports.setCookieUntil = exports.checkLogin = exports.getCookie = exports.deleteAllCookies = exports.deleteCookie = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _domain = require("./domain");

var _jwt = require("./jwt");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * 刪除單一 cookie
 * @param {string} cname
 */
var deleteCookie = function deleteCookie(cname) {
  document.cookie = "".concat(cname, "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/").concat((0, _domain.getCookieDomainPart)());
};
/**
 * 清掉當前父網域底下所有 cookie
 */


exports.deleteCookie = deleteCookie;

var deleteAllCookies = function deleteAllCookies() {
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    deleteCookie(name.trim());
  }
};
/**
 * 讀取 cookie
 * @param {string} name
 * @returns {string|null}
 */


exports.deleteAllCookies = deleteAllCookies;

var getCookie = function getCookie(name) {
  var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
  return v ? v[2] : null;
};

exports.getCookie = getCookie;

var checkLogin = function checkLogin(cookieLoginName) {
  var gettoken = getCookie(cookieLoginName);

  if (gettoken) {
    return gettoken;
  }

  return "";
};
/** token 沒帶 exp 時的保底有效天數 */


exports.checkLogin = checkLogin;
var COOKIE_FALLBACK_DAYS = 1;
/**
 * 寫入 cookie 並指定到期時間
 * @param {string} cname
 * @param {string} cvalue
 * @param {Date|null} expireDate 傳 null 寫成 session cookie（關閉瀏覽器即失效）
 */

var setCookieUntil = function setCookieUntil(cname, cvalue, expireDate) {
  var expires = expireDate ? "expires=".concat(expireDate.toUTCString(), ";") : "";
  document.cookie = "".concat(cname, "=").concat(cvalue, ";").concat(expires, "path=/").concat((0, _domain.getCookieDomainPart)());
};
/**
 * 寫入 cookie
 * @param {string} cname
 * @param {string} cvalue
 * @param {number} [exdays] 有效天數，沒給的話預設 1 天
 */


exports.setCookieUntil = setCookieUntil;

var setCookie = function setCookie(cname, cvalue) {
  var exdays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : COOKIE_FALLBACK_DAYS;
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  setCookieUntil(cname, cvalue, d);
};
/**
 * 依 JWT 自己的 exp 寫入 cookie，讓 cookie 的生命週期跟著 token 走
 *
 * token 效期由發證方（Nani Club / OneClub）決定且會調整，前端不寫死天數。
 * 拿不到 exp 時才退回 COOKIE_FALLBACK_DAYS。
 * @param {string} cname
 * @param {string} cvalue 實際寫進 cookie 的值，不一定等於 jwt 本身
 * @param {string} jwt 用來讀 exp 的 token
 */


exports.setCookie = setCookie;

var setCookieByJwtExpire = function setCookieByJwtExpire(cname, cvalue, jwt) {
  var expireDate = (0, _jwt.getJwtExpireDate)(jwt);

  if (!expireDate) {
    setCookie(cname, cvalue, COOKIE_FALLBACK_DAYS);
    return;
  }

  setCookieUntil(cname, cvalue, expireDate);
};

exports.setCookieByJwtExpire = setCookieByJwtExpire;

var exportFile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, method, payload) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            (0, _axios.default)({
              url: url,
              method: method || "get",
              data: payload,
              responseType: "blob"
            }).then(function (res) {
              var fileName = decodeURI(res.headers["content-disposition"].replace(/\w+;filename=(.*)/, "$1")).split("UTF-8''")[1];
              var url = window.URL.createObjectURL(new Blob([res.data]));
              var link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
            });

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function exportFile(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

exports.exportFile = exportFile;